import { paymentStatusesTr } from './statuses'
import { cancellationReasonsTr } from './cancellationReasons'

export const translationTr = {
  ...paymentStatusesTr,
  ...cancellationReasonsTr,
  // Company Code Form
  welcome: 'Hoş Geldiniz',
  companyCodeInfo:
    'Yeni bir rapor oluşturmak için Şirket kodunuzu girin veya daha önce gönderilmiş bir raporun durumunu kontrol edin.',
  companyCodeLabel: 'Şirket erişim kodu',
  companyCodeInputPlaceholder: 'Yeni Rapor oluşturmak için erişim kodunu girin',
  companyCodeNotFound:
    'Bu koda sahip bir şirket bulunamadı. Lütfen kontrol edip tekrar deneyin.',
  statusOfExistingReport: 'Mevcut Raporun Durumu',
  createNewReport: 'Yeni Rapor oluştur',
  companyCode: 'Şirket kodu',

  // Access Report Modal
  accessReportModalTitle: 'Erişim için gereken Özgün Kod',
  accessReportModalText:
    'Raporu gönderdiğiniz anda size özgün bir kod verildi. Lütfen kodu aşağıdaki giriş alanına yapıştırın.',
  accessReportModalLabel: 'Özgün Kod',
  accessReportModalPlaceholder: 'Erişim kodunu girin',
  accessReportModalCancelBtn: 'İptal',
  accessReportModalChecklBtn: 'Raporu Kontrol Et',

  // Save Token Modal
  saveTokenTitle: 'Rapor teslim edildi. Aşağıdaki kodu kaydedin:',
  saveTokenImportant: 'ÖNEMLİ:',
  saveTokenImportantNote:
    'Aşağıdaki kodu kaydedin ve güvenli bir şekilde saklayın. Kodu kimseyle paylaşmayın. Bu kod ile ilerlemesini takip etmek ve mesajları görmek için raporunuza erişebileceksiniz.',
  saveTokenUniqueCodeLabel: 'Özgün Kodunuz',
  saveTokenReceivedReport:
    'Raporunuzu aldık ve en kısa sürede size geri döneceğiz.',
  saveTokenReportInfo:
    'Gönderdiğiniz raporunuzu aşağıdan indirebilir/dışa aktarabilir veya bitirmek için "Tamamla"yı tıklayabilirsiniz.',
  saveTokenExportBtn: 'Raporu Dışarıya Aktar',
  saveTokenCompleteBtn: 'Tamamlandı',

  // Delete Resource Modal
  areYouSureWantToDelete: 'Bu kullanıcıyı silmek istediğinizden emin misiniz?',
  areYouSureWantToDeleteThisCategory:
    'Bu kategoriyi silmek istediğinizden emin misiniz?',
  areYouSureWantToDeleteThisBranch:
    'Bu Branch silmek istediğinizden emin misiniz?',
  yesIamSure: 'Evet eminim',
  noCancel: 'Hayır, iptal et',

  // Resolution Option Modal
  areYouSureWantToCloseThisCase:
    'Bu vakayı kapatmak istediğinizden emin misiniz?',
  youAreAboutToCloseThisCase: 'Bu vakayı kapatmak üzeresiniz',
  theCaseWillBe: 'Vaka olacak',
  howWouldYouLikeToResolveThisCase: 'Bu vakayı nasıl çözmek istersiniz?',
  yesCloseTheCase: 'Evet, vakayı kapat',
  noIamNotReady: 'Hayır, hazır değilim',
  archived: 'Arşivlendi',
  resolved: 'Çözümlendi',

  // Report Form
  reportAnOccurrenceText:
    'Kuruluşun politikalarına ve prosedürlerine aykırı olan çeşitli suistimal, dolandırıcılık veya uyum ihlalleriyle ilgili beklenmedik olayları bildirmek için bu formu kullanın. ReportAll formu, bir soruşturmanın yapılıp yapılmayacağını ve nasıl yürütüleceğini belirlemek için ilgili bilgileri talep eder. Gizlilik yüksek düzeyde korunur ve uyum görevlileri her türlü kişisel bilgiyi korumakla yükümlüdür.',
  makeReport: 'Rapor Hazırla',
  checkReport: 'Raporu Kontrol Et',
  review: 'Gözden geçir',
  startReport: 'Raporu Başlat',
  typeOfReport: 'Rapor Türü',
  category: 'Kategori',
  branch: 'Branch',
  fullName: 'Ad Soyad',
  telephone: 'Telefon',
  questions: 'Sorular',
  whenDidTheIncidentOccur: 'Olay ne zaman meydana geldi?',
  isTheIncidentStillOngoing: 'Olay hala devam ediyor mu?',
  whereDidTheIncidentOccur: 'Olay nerede meydana geldi?',
  whoIsInvolvedAndWhatIsTheirCapacity: 'Kimler dahil ve ünvanları nedir?',
  nameSurnameAndTheirCapacity: 'Ad Soyad ve ünvanları',
  fullDescriptionOfTheIncident: 'Olayın Tam Açıklaması',
  regular: 'Sürekli',
  anonymous: 'İsimsiz',
  attachments: 'Ekler',
  uploadFilesTitle: 'Raporunuzla ilgili tüm dosyaları yükleyebilirsiniz.',
  dragHere: 'Dosyaları Yüklemek için buraya sürükleyin',
  supportedFiles: 'Desteklenen Dosyalar',
  addFile: 'Dosya Ekle',
  reportAnOccurrence: 'Bir olayı bildir',
  anonymousReporting: 'İsimsiz raporlama',
  regularReporting: 'Sürekli raporlama',
  chooseIncidentcategory: 'Olay kategorisini seçin',
  choose: 'Seçin',
  anonymousText:
    'Bu Bildirim, şikayetçiden herhangi bir kişisel veri ve/veya iletişim bilgisi gerektirmediğinden isimsizdir. Lütfen bu durumda Raporunuzun takibine yalnızca Raporun sunulması üzerine size sağlanan erişim kodu aracılığıyla izin verildiğini unutmayın.',
  regularText:
    'Bu Raporlama, gönderilmeden önce kişisel verilerinizi ve/veya iletişim bilgilerinizi isteyebilir. Lütfen adınız dışında bu tür bilgilerin zorunlu olmadığını unutmayın. Her durumda, Raporunuz en üst düzeyde gizlilikle ele alınacaktır.',
  optional: 'isteğe bağlı',
  back: 'Geri',
  nextStep: 'Sonraki adım',
  submitReport: 'Rapor gönder',
  noAttachmentsFound: 'Ek bulunamadı',
  textHere: 'Buraya Yazın',
  freeTextSmallField: 'Serbest Küçük Metin Alan',
  freeTextLargeField: 'Serbest Büyük Metin Alanı',
  details: 'Detaylar',
  assignTo: 'Görevlendir',
  caseOverview: 'Vaka Genel Bakış',
  activityLog: 'Etkinlik Günlüğü',
  submit: 'İbraz et',
  search: 'Arama',
  yes: 'Evet',
  no: 'Hayır',
  writeYourFullName: 'Tam adınızı yazın',
  writeYourEmail: 'E-postanızı yazın',
  writeYourTelephone: 'Telefon numaranızı yazın',
  writeThePlaceOfTheIncident: 'Olayın yerini yazınız',
  addTheNamesOfThePeopleInvolved: 'İlgili kişilerin adlarını ekleyin',
  describeIncident:
    'Lütfen olayı açıklayın (Ne oldu? Nasıl oldu? vb.) Mümkün olduğunca kesin ve apaçık olun.',
  report: 'Rapor',
  export: 'Dışarı aktar',
  caseDetails: 'Vaka Ayrıntıları',
  yourMessages: 'Mesajlarınız',
  yourMessagesInfo:
    'Burada, raporunuzla ilgili daha fazla bilgi eklemek için durumunuzu üstlenen uyum görevlisiyle iletişime geçebilirsiniz.',
  UNASSIGNED: 'Atanmamış',
  IN_PROGRESS: 'İlerleme halinde',
  CLOSED: 'Kapanmış',
  TOTAL: 'Toplam',
  selectBranch: 'Select Branch',

  // Navigation
  dashboard: 'Gösterge Paneli',
  reports: 'Raporlar',
  users: 'Kullanıcılar',
  settings: 'Ayarlar',
  statistics: 'İstatistikler',
  categories: 'Kategoriler',
  branches: 'Branches',

  // Admin
  newUser: 'Yeni Kullanıcı',
  editUser: 'Kullanıcıyı Düzenle',
  saveNewUser: 'Yeni Kullanıcıyı Kaydet',
  userName: 'Kullanıcı Adı',
  firstName: 'Ad',
  lastName: 'Soyad',
  password: 'Şifre',
  position: 'Görev',
  language: 'Dil',
  newCategory: 'Yeni Kategori',
  newBranch: 'Yeni branch',
  editCategory: 'Kategoriyi Düzenle',
  editBranch: 'Branch Düzenle',
  insertCategory: 'Kategori Ekle',
  insertName: 'İsim Ekle',
  saveCategory: 'Kategoriyi Kaydet',
  noCategoriesFound: 'Kategori bulunamadı',
  noDataFound: 'Veri bulunamadı',
  changePassword: 'Şifre değiştir',
  updateCompanyName: 'Şirket Adını Güncelle',
  updatePrivacyPolicy: 'Gizlilik Politikasını Güncelle',
  enterLink: 'Gizlilik Politikası Bağlantısını Girin',
  updateLogo: 'Logoyu Güncelle',
  companyLogo: 'Şirket Logosu',

  // Compliance Officer
  complianceOfficer: 'Uyum Görevlisi',
  visibility: 'Görünürlük',
  created: 'Oluşturuldu',
  status: 'Durum',
  overviewStatistics: 'İstatistiklere Genel Bakış',
  complianceOfficerNotes: 'Uyum Görevlisi Notları',
  complianceOffcerNoteCreatedBy: 'Uyum Görevlisi Notunu oluşturan:',
  youHaventAddedNotes: 'Bu vakaya henüz herhangi bir not eklemediniz.',
  onlyAssignedCoOfficerCanViewMessages:
    'Mesajları yalnızca atanan Uyum Görevlisi görebilir.',
  characterLimit: 'Karakter Sınırı',
  noteLimit: 'Mesaj en fazla 320 karakter olmalıdır',
  closeCase: 'Vakayı Kapat',
  resolutionOption: 'Çözünürlük Seçeneği',
  archivedClosed: 'Arşiv (Kapalı)',
  resolvedClosed: 'Çözümle (Kapalı)',
  caseClosed: 'Vaka Kapandı',
  caseHasBeenClosed: 'Vaka kapatıldı',
  failedToCloseCase: 'Vaka kapatılamadı',
  REPORT_CREATED: 'Rapor Oluşturuldu',
  COMPLIANCE_OFFICER_ASSIGNED: 'Uyum Görevlisi Atandı:',
  REPORT_STATUS_CHANGED: 'Rapor Durumu Değiştirildi:',
  REPORT_NOTE_CREATED: 'Rapor Notu Oluşturuldu',
  REPORT_EDITED: 'Rapor Düzenlendi',

  // Table
  showing: 'Gösteriliyor',
  to: 'ile',
  entries: 'girişler',
  of: 'hakkında',
  pages: 'sayfalar',
  ANONYMOUS: 'İsimsiz',
  noReportsFound: 'Rapor Bulunamadı',
  noUsersFound: 'Kullanıcı bulunamadı',

  // Charts
  mostReportedCategories: 'En çok rapor edilen kategoriler',
  conclusionType: 'Sonuç türü',
  numberNatureOfReports: 'Rapor Sayısı / Niteliği',
  total: 'Tüm Raporlar',
  other: 'Diğer',
  noDataFoundForTheSelectedPeriod: 'Seçilen dönem için veri bulunamadı',

  // Toast messages
  copiedToClipboard: 'Panoya kopyalandı',
  aUserWithThisEmailAlreadyExists: 'Bu e-postaya sahip bir kullanıcı zaten var',
  aUserWithThisUsernameAlreadyExists:
    'Bu kullanıcı adına sahip bir kullanıcı zaten var',
  failedToCreateUser: 'Kullanıcı oluşturulamadı',
  userHasBeenCreated: 'Kullanıcı oluşturuldu',
  userHasBeenUpdated: 'Kullanıcı güncellendi',
  failedToUpdateUser: 'Kullanıcı güncellenemedi',
  userHasBeenDeleted: 'Kullanıcı silindi',
  failedToDeleteUser: 'Kullanıcı silinemedi',
  failedToSubmitNote: 'Not gönderilemedi',
  failedToLoadReports: 'Raporlar yüklenemedi',
  failedToCreateCategory: 'Kategori oluşturulamadı',
  categoryHasBeenCreated: 'Kategori oluşturuldu',
  categoryHasBeenDeleted: 'Kategori silindi',
  failedToDeleteCategory: 'Kategori silinemedi',
  categoryHasBeenUpdated: 'Kategori güncellendi',
  branchHasBeenUpdated: 'Branch güncellendi',
  failedToUpdateBranch: 'Branch güncellenemedi',
  branchHasBeenDeleted: 'Branch silindi',
  failedToDeleteBranch: 'Branch silinemedi',
  categoryHasAttachedReports_one:
    'Silinemez: {{count}} rapor bu kategori altında kayıtlı.',
  categoryHasAttachedReports_other:
    'Silinemez: {{count}} rapor bu kategori altında kayıtlı.',
  branchHasAttachedReports_one:
    'Silinemez: {{count}} rapor bu branch altında kayıtlı.',
  branchHasAttachedReports_other:
    'Silinemez: {{count}} rapor bu branch altında kayıtlı.',
  attachedReportsUnknown: 'Rapor listesi yüklenene kadar kullanılamaz.',
  failedToUpdateCategory: 'Kategori güncellenemedi',
  branchHasBeenCreated: 'Branch oluşturuldu',
  failedToCreateBranch: 'Branch oluşturulamadı',
  submitFailed: 'Gönderilemedi',
  aResetLinkHasBeenSentToYourEmail:
    'E-postanıza bir sıfırlama bağlantısı gönderildi.',
  InvalidUsernameOrPassword: 'Geçersiz kullanıcı adı veya şifre',
  humanVerificationFailed:
    'Güvenlik doğrulaması başarısız oldu. Lütfen tekrar deneyin.',
  yourPasswordHasBeenResetsussfully: 'Şifreniz başarıyla sıfırlandı.',
  failedToResetPassword: 'Failed to reset password',
  yourPasswordHasBeenChanged: 'Şifreniz başarıyla değiştirildi.',
  failedToChangePassword: 'Şifre değiştirilemedi',
  companyNameHasBeenUpdated: 'Şirket adı güncellendi',
  failedToUpdateCompanyName: 'Şirket adı güncellenemedi',
  sessionExpired: 'Oturumunuz sona erdi. Lütfen tekrar giriş yapın.',
  failedToSendMessage: 'Mesaj gönderilemedi',
  failedToLoadMessages: 'Mesajlar yüklenemedi',
  privacyPolicyHasBeenUpdated: 'Gizlilik Politikası güncellendi',
  failedToUpdatePrivacyPolicy: 'Gizlilik politikası güncellenemedi',
  logoHasBeenUpdated: 'Logo güncellendi',
  failedToUpdateLogo: 'Logo güncellenemedi',
  caseAssigned: 'Vaka başarıyla atandı',

  // Error messages
  somethingWentWrongFailedToLoadNotes:
    'Bir şeyler ters gitti, notlar yüklenemedi',

  //Validation Messages
  requiredField: 'Gerekli Alan',
  invalidEmail: 'Geçersiz E-posta',
  invalidPhone: 'Geçersiz Telefon',

  logout: 'Oturumu Kapat',
  logIn: 'Oturum Aç',
  enterCredentials: 'Hesabınıza erişmek için Kullanıcı Bilgilerinizi girin.',
  resetPassword: 'Şifreyi Sıfırla',
  forgotPassword: 'Şifrenizi unuttunuz mu?',
  insertUsername: 'Kullanıcı Adı Ekle',
  insertPassword: 'Şifre Ekle',
  insertEmail: 'E-posta Ekle',
  enterYourEmailToResetYourPassword:
    'Şifrenizi sıfırlamak için e-postanızı girin.',
  enterNewPassword: 'Yeni Şifreyi Girin',
  confirmPassword: 'Şifreyi Onayla',
  passwordMustBeAtLeast8CharactersAndContainAtLeastOneUppercaseLetterAndOneNumber:
    'Şifre en az 8 karakter olmalı ve en az bir büyük harf bir rakam ve bir özel karakter içermelidir.',
  passwordsMustMatch: 'Şifreler aynı olmalıdır',

  'Select Position': 'Ünvan Seçin',
  'Compliance Officer': 'Uyum Görevlisi',
  Administrator: 'Yönetici',
  HR: 'İK',
  COMPLIANCE_OFFICER: 'Uyum Görevlisi',
  ADMINISTRATOR: 'Yönetici',

  chooseResolutionOption: 'Çözünürlük seçeneğini seçin',
  'Case Dismissed': 'Vaka Reddedildi',
  Lawsuit: 'Dava',
  'Report to Other Authorities': 'Diğer Yetkililere Bildirin',
  'Resolved Internally': 'Dahili Olarak Çözüldü',

  IhaveReadAndAgreeWithThe: 'Okudum ve Katılıyorum',
  iHaveReadAndUnderstoodThe: 'Okudum ve Katılıyorum',
  termsAndConditions: 'Şartlar ve Koşullar',
  iHaveReadAndUnderstoodTheLicenseAgreement:
    'Okudum, anladım ve tamamen kabul ediyorum',
  endUserLicenseAgreement: 'Son Kullanıcı Lisans Sözleşmesi',
  privacyPolicy: 'Gizlilik Politikası',
  IhaveBeenInformedAboutTheProcessingOfMyData:
    'Kişisel verilerimin işlenmesi konusunda bilgilendirildim.',
  privacyStatement: 'Gizlilik Bildirimi',
  Jan: 'Oca',
  Feb: 'Şub',
  Mar: 'Mar',
  Apr: 'Nis',
  May: 'May',
  Jun: 'Haz',
  Jul: 'Tem',
  Aug: 'Ağu',
  Sep: 'Eyl',
  Oct: 'Eki',
  Nov: 'Kas',
  Dec: 'Ara',

  CASE_DISMISSED: 'Vaka Reddedildi',
  LAWSUIT: 'Dava',
  REPORT_TO_OTHER_AUTHORITIES: 'Diğer Yetkililere Bildirin',
  RESOLVED_INTERNALLY: 'Dahili Olarak Çözüldü',

  tooltipLogo:
    'Bir ihbarcı şirketinize bir rapor gönderdiğinde şirket logosu gösterilecektir.',
  somethingWentWrongPleaseTryAgain: 'Bir sorun oluştu, lütfen tekrar deneyin.',
  reviewPlan: 'Planı',
  billing: 'Faturalandırma',
  changePlan: 'Planı Değiştir',
  next: 'Sonraki',
  payNow: 'Sekilde Ode',
  email: 'Email',
  username: 'Kullanıcı Adı',
  detailsDescription:
    'Bilgilerinizi girin. Ödeme tamamlandığında otomatik olarak bir hesap oluşturulacaktır.',
  billingInformation: 'Fatura Bilgileri',
  billingInformationDescription:
    "Ödemeyi tamamlamak için Fatura Bilgilerinizi girin. Ad ve adresiniz faturalarınızda görünür. Stripe'a güvenli bir şekilde yönlendirileceksiniz.",
  companyName: 'Yatırım Sirketi Adıς',
  companyEmail: 'Yatırım Sirketi E-postası',
  companyTaxId: 'Vergi Numarası',
  country: 'Ulkeler',
  state: 'Bölge',
  city: 'Sehir',
  postalCode: 'Posta Kodu',
  address1: 'Adres 1',
  address2: 'Adres 2',
  loginToYourAccount: 'Hesabınıza giriş yapın',
  paymentSuccessTitle: 'Ödemeniz başarıyla gerçekleştirildi',
  paymentSuccessText:
    'Ödemenizi aldık ve size giriş bilgilerinizi içeren bir e-posta gönderdik.',
  planAndBilling: 'Plan ve Faturalandırma',
  youAreOnThe: 'Şu anda',
  membershipPlan: 'üyelik planı',
  thisSubscriptionIsValidTill: 'Bu abonelik şu tarihe kadar geçerlidir',
  itWillAutomaticallyRenew:
    'Abonelik önceden iptal edilmedikçe, fatura döneminin sonunda otomatik olarak yenilenecektir.',
  thePriceOfMembership: 'Üyelik ücreti',
  plusVat: '+KDV',
  myPlan: 'Planım',
  myInvoices: 'Faturalarım',
  cancelSubscription: 'Aboneliği İptal Et',
  reActivateSubscription: 'Aboneliği Yeniden Etkinleştir',
  cancelSubscriptionDescription:
    'Aboneliğinizi iptal etmek istediğinizden emin misiniz? Fatura dönemi sonuna kadar aktif kalacaktır. Fatura dönemi sonuna kadar istediğiniz zaman yeniden etkinleştirebilirsiniz.',
  reactivateSubscriptionDescription:
    'Aboneliğinizi yeniden etkinleştirmek istediğinizden emin misiniz? Fatura dönemi sona ermeden önce istediğiniz zaman tekrar iptal edebilirsiniz.',
  subscriptionCancelled: 'Abonelik, fatura döneminin sonunda iptal edilecektir',
  subscriptionReactivated:
    'Abonelik iptali geri alındı. Aboneliğiniz devam edecek',
  // Cancellation feedback. The reason is required by us, not by the backend,
  // which accepts a cancellation without one - see ModalCancelSubscription.
  whyAreYouCancelling: 'Aboneliğinizi neden iptal ediyorsunuz?',
  selectAReason: 'Bir neden seçin',
  anythingElseYouWouldLikeToTellUs:
    'Bize iletmek istediğiniz başka bir şey var mı?',
  notGiven: 'Belirtilmedi',
  itWillBeCancelledAtTheEndOfTheBillingPeriod:
    'Fatura döneminin sonunda iptal edilecektir.',
  chargeDate: 'Ücretlendirme tarihi',
  billingPeriod: 'Fatura dönemi',
  amount: 'Miktar',
  user: 'Kullanıcı',
  company: 'Şirket',
  personalInformationHasBeenUpdated:
    'Kişisel bilgileriniz başarıyla güncellendi',
  duplicateEmail: 'Bu e-posta adresi zaten kullanılıyor',
  duplicateUsername: 'Bu kullanıcı adı zaten kullanılıyor',
  save: 'Kaydet',
  edit: 'Düzenle',
  delete: 'Sil',
  cancel: 'Iptal',
  personalInformation: 'Kişisel Bilgiler',
  general: 'Genel',
  security: 'Güvenlik',
  update: 'Güncelleme',
  companyProfile: 'Şirket Profili',
  billingInformationHasBeenUpdated: 'Fatura bilgileriniz başarıyla güncellendi',
  yourPlan: 'Planınız',
  expiresIn: 'Süre sonu',
  youHaveSelectedThe: 'Seçtiğiniz',
  month: 'ay',
  months: 'aylar',
  yourUniversity: 'üniversite',
  students: 'öğrenciler',
  employees: 'çalışanlar',
  upTo: 'kadar',
  upTo2: 'Kadar',
  moreThan: 'daha fazla',
  moreThan2: 'Daha fazla',
  seatsPlanDescription:
    'Bu plan, {{productType}} ürününüzün {{range}} {{seats}} {{unit}} adedini kaydetmeyi amaçlamaktadır.',
  myPlanDescription:
    'Bu abonelik {{months}} {{monthsLabel}} aiçindir ve şunları içerir: İlk €{{price}} için {{months}} {{monthsLabel}}  - bu süreden sonra, abonelik süre bitmeden iptal edilmedikçe, sonraki  €{{price}} will be charged for the following {{months}} {{monthsLabel}}, için {{price}} € tutarında yinelenen bir ücret tahsil edilecektir.',
  changePlanDescription:
    'İhtiyacınız olan işlevlere ve kuruluşunuzdaki çalışan/öğrenci sayısına göre işinizin gereksinimlerine uygun planı seçin. Yeni fatura dönemi, mevcut fatura döneminin sonunda başlayacaktır.',
  selectYourPlanTitle: 'Planınızı seçin',
  selectYourPlanDescription:
    'İhtiyacınız olan işlevlere ve kuruluşunuzun kaç çalışanı/öğrencisine bağlı olarak iş taleplerinize uygun planı seçin.',
  studentsUnit: 'çalışanlar',
  employeesUnit: 'çalışanlar',
  companies: 'Șirketler',
  universities: 'Üniversiteler',
  standardPlanTitle: 'Standart',
  monthly: 'Aylık',
  yearly: 'Yıllık',

  // Super admin cancellations table
  cancellations: 'İptaller',
  plan: 'Plan',
  reason: 'Neden',
  comment: 'Yorum',
  cancelledBy: 'İptal eden',
  cancelledOn: 'İptal tarihi',
  accessEnds: 'Erişim bitişi',
  allReasons: 'Tüm nedenler',
  allCancellations: 'Tüm iptaller',
  reversed: 'Geri alındı',
  stillStanding: 'Yürürlükte',
  noCancellationsFound: 'İptal bulunamadı',
  annually: 'Yıllık',
  vatExclusive: 'aylık KDV hariç',
  featureFullAnonymity: 'Tam Anonimlik',
  featureCompliance: 'Uyma',
  featureLocalization: 'Yerelleştirme',
  featureFollowUp: 'Bildirimler',
  featureConfigurations: 'Konfigürasyonlar',
  featureUserRoles: 'Kullanıcı rolleri',
  featureIdentityProtection: 'Kimlik koruması',
  featureReportsManagement: 'Rapor Yönetimi ve Günlüğü',
  featureCustomLogo: 'Özel logo',
  featureCustomerSupport: 'Müşteri desteği',
  featureAttachments: 'Ekler',
  getStartedButton: 'Şimdi al',
  activePlan: 'Aktif plan',
  cancelPlanUpdate: 'Plan Güncellemesini İptal Et',
  planChangedSuccessfully: 'Plan başarıyla değiştirildi',
  failedToChangePlan: 'Plan değiştirilemedi',
  planChangeCancelledSuccessfully: 'Plan değişikliği başarıyla iptal edildi',
  failedToCancelChangePlan: 'Değişiklik planını iptal edemedi',
  allFieldsAreRequired: 'Tüm alanların doldurulması zorunludur',
  allConsentsRequired:
    'Şartlar ve Koşullar, Gizlilik Politikası ve Son Kullanıcı Lisans Sözleşmesini kabul etmelisiniz.',
  pleaseFillAllTheRequiredFields: 'Lütfen tüm zorunlu alanları doldurun',
  noCategoriesFoundInitial:
    'Henüz kategori yok. İnsanların yeni raporlar oluşturabilmesi için önce bir kategori oluşturun.',
  payment: 'Ödeme',
  confirm: 'Onayla',
  paymentInformation: 'Ödeme Bilgileri',
  paymentInformationDescription:
    "Satın alma işleminizi tamamlamak için lütfen ödeme yöntemini seçin. Kartla ödeme için Stripe'a güvenli bir şekilde yönlendirileceksiniz.",
  cardPayment: 'Kartla ödeme',
  manualBankTransfer: 'Banka havalesi',
  organizations: 'Kuruluşlar',
  transactions: 'İşlemler',
  noOrganizationsFound: 'Hiçbir kuruluş bulunamadı',
  subscriptionEod: 'Abonelik sona erdi',
  active: 'Aktif',
  organization: 'Organizasyon',
  subscription: 'Abonelik',
  paymentMethod: 'Ödeme yöntemi',
  subscriptionPeriod: 'Abonelik süresi',
  companyNameColumn: 'Şirket adı',
  invoiceNo: 'Fatura No.',
  method: 'Yöntem',
  card: 'Kart',
  manualPayment: 'Manuel ödeme',
  noTransactionsFound: 'İşlem bulunamadı',
  selectDateRange: 'Tarih aralığı seçin',
  viewTransactions: 'İşlemleri görüntüle',
  activateAccount: 'Hesabı etkinleştir',
  updateEod: 'Bitiş tarihini güncelle',
  updateEodDescription:
    'Bu kuruluş için yeni bir abonelik bitiş tarihi belirleyin.',
  accountActivatedSuccessfully: 'Hesap başarıyla etkinleştirildi',
  provisionalPeriod: 'geçici',
  provisionalPeriodNote:
    'Onaylanmamış banka havalesi için geçici süre. Abonelik, ödemenin onaylandığı tarihten itibaren başlar.',
  noSubscriptionToActivate:
    'Bu kuruluş için abonelik bulunamadı, bu nedenle etkinleştirilecek bir şey yok.',
  failedToActivateAccount: 'Hesap etkinleştirilemedi',
  subscriptionEodUpdated: 'Abonelik bitiş tarihi güncellendi',
  failedToUpdateSubscriptionEod: 'Abonelik bitiş tarihi güncellenemedi',
  noOrganizationsUsersFound: 'Kullanıcı bulunamadı',
  pending: 'Beklemede',
  download: 'İndir',
  view: 'Görüntüle',
  expand: 'Genişlet',
  collapse: 'Daralt',
  value: 'Değer',
  mailAddress: 'E-posta adresi',
  sendMessage: 'Mesaj Gönder',
  support: 'Destek',
  howCanWeHelpYou: 'Size nasıl yardımcı olabiliriz?',
  supportFormTitle: 'Görüşmeye başlamak için lütfen aşağıdaki formu doldurun.',
  supportFormDescription:
    'Destek ekibimiz e-postaları genellikle bir iş günü içinde yanıtlar.',
  subject: 'Konu',
  supportSubjectPlaceholder: 'Mesajınız ne hakkında?',
  subjectMustBeAtLeast5Characters: 'Konu en az 5 karakter olmalıdır',
  messageMustBeAtLeast10Characters: 'Mesaj en az 10 karakter olmalıdır',
  supportMessageLabel:
    'Neye ihtiyacınız olduğunu ve nasıl yardımcı olabileceğimizi bize bildirin',
  yourMessageHere: 'Mesajınız buraya',
  supportMessageSent: 'Mesajınız gönderildi',
  failedToSendSupportMessage: 'Mesajınız gönderilemedi',
  exit: 'Çıkış',
  goToLogin: 'Girişe git',
  bankTransferSentTitle:
    'Kayıtlı şirket e-posta adresine bir e-posta gönderildi.',
  bankTransferSentDescription:
    'Lütfen e-postadaki talimatları izleyin ve ödemeyi en kısa sürede tamamlayın. ReportAll hesabınız yalnızca ödeme alındıktan sonra etkinleştirilecektir. Aboneliğinizi ve ayarlarınızı görüntülemeye devam edebilirsiniz, ancak tam erişim etkinleştirmeden sonra sağlanacaktır.',
  planUpdateNotActiveBanner:
    'ReportAll plan güncellemeniz henüz etkin değil. Ödemeniz alındığında ve yeni üyelik planınız etkinleştirildiğinde sizinle iletişime geçeceğiz.',
  accountNotActivatedBanner:
    'ReportAll hesabınızın etkinleştirilmesi henüz tamamlanmadı. Lütfen ödemenizi yapın ve etkinleştirmeyi onaylamamız için bize bildirin.',
  accountAwaitingActivationAdmin:
    'Hesabınız etkinleştirilmeyi bekliyor. Tam erişimi geri kazanmak için ödemenizi onaylayın.',
  disabledUntilActivation: 'Hesabınız etkinleştirilene kadar kullanılamaz.',
  confirmPayment: 'Ödemeyi Onayla',
  paymentOptions: 'Ödeme Seçenekleri',
  managePaymentMethod: 'Ödeme yönteminizi yönetin.',
  showSubscriptionBankDetails: 'Abonelik banka bilgilerini göster',
  hideSubscriptionBankDetails: 'Abonelik banka bilgilerini gizle',
  accountAwaitingActivation:
    'Kuruluşunuz etkinleştirilmeyi bekliyor. Lütfen yöneticinizle iletişime geçin.',
  invoiceHistoryNote:
    'Fatura geçmişine hesap üzerinden yalnızca son 3 yıl için erişilebilir. Daha eski fatura geçmişine erişmek isterseniz lütfen Müşteri Destek ile iletişime geçin.',
  noInvoicesFound: 'Fatura bulunamadı',
  paymentConfirmationSent: 'Ödeme onayı gönderildi',
  failedToConfirmPayment: 'Ödeme onayı gönderilemedi',
  tryAgain: 'Tekrar deneyin',
  failedToLoadInvoices: 'Faturalar yüklenemedi',
  failedToLoadPlan: 'Planınız yüklenemedi',
  noActiveSubscription: 'Etkin abonelik bulunamadı',
  upToDescription: '{{productType}} için {{range}} {{seats}} {{unit}}.',
  pendingPlanDescription:
    'Güncellenen abonelik {{startingDate}} tarihinde başlar. Bu abonelik {{months}} {{monthsLabel}} boyunca geçerlidir. Abonelik önceden iptal edilmediği sürece fatura döneminin sonunda otomatik olarak yenilenir.',
  subscriptionManagedBySupport:
    'Aboneliğiniz banka havalesiyle ödenmektedir ve ReportAll ekibi tarafından yönetilir. Planınızı değiştirmek veya iptal etmek için lütfen destek ekibiyle iletişime geçin.',
  failedToLoadBillingInformation: 'Fatura bilgileri yüklenemedi',
  noBillingInformationFound: 'Fatura bilgisi bulunamadı',
  currentPasswordIsIncorrect: 'Mevcut şifre hatalı',
  currentPassword: 'Mevcut Şifre',
  newPassword: 'Yeni Şifre',
  reEnterNewPassword: 'Yeni Şifreyi Tekrar Girin',
  keepMeSignedIn: 'Oturumum açık kalsın',
  sort: 'Sırala',
  allStatuses: 'Tüm durumlar',
  allMethods: 'Tüm ödeme yöntemleri',
}
